import styled from 'styled-components'
import { Swiper as SwiperReact } from 'swiper/react'
import { IcArrowLeft, IcChevronRightBlack, IcCloseWhite } from '../../Icons'

export const Content = styled.div`
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  flex-direction: column;
  height: 100vh;
  justify-content: space-between;
  left: 0;
  overflow: scroll;
  position: fixed;
  top: 0;
  width: 100%;
  z-index: ${({ theme }) => theme.zIndex?.imageGallery ?? 2000};

  &::-webkit-scrollbar {
    display: none;
  }

  @media (max-width: 1024px) {
    height: 100vh;
  }
`

export const Close = styled.button`
  background-color: transparent;
  background-image: url(${IcCloseWhite});
  background-repeat: no-repeat;
  height: 24px;
  position: absolute;
  right: 14px;
  top: 14px;
  transition: ease-in-out 0.3s;
  width: 24px;
  z-index: ${({ theme }) => (theme.zIndex?.imageGallery ?? 2000) + 1};
  border: 0;

  &:hover,
  &:active {
    background-image: url(${IcCloseWhite});
  }
`

export const Container = styled.div`
  margin-bottom: 36px;
  max-height: 84vh;

  img {
    max-height: 80vh;
    max-width: 100%;
  }

  h1 {
    color: ${({ theme }) => theme?.colors?.white ?? '#fff'};
    font-size: 14px;
    line-height: 27px;
    padding: 10px;
    text-align: center;
  }

  .swiper-container {
    .swiper-slide {
      cursor: context-menu !important;
      display: flex;
      justify-content: center;
      max-height: 100%;
      opacity: 1;
    }
  }
`

export const Swiper = styled(SwiperReact)`
  .swiper-button-prev,
  .swiper-button-next {
    background-color: ${({ theme }) => theme?.colors?.white ?? '#fff'};
    color: ${({ theme }) => theme?.colors?.textColor ?? '#273240'};
    border-radius: 50%;
    cursor: pointer;
    display: flex;
    height: 30px;
    position: absolute;
    top: 50%;
    width: 30px;
    z-index: ${({ theme }) => (theme.zIndex?.imageGallery ?? 2000) + 10};

    &::after {
      background-color: ${({ theme }) => theme?.colors?.textColor ?? '#273240'};
      content: '';
    }
  }

  .swiper-button-prev {
    background-image: url(${IcArrowLeft});
    background-position: center;
    background-repeat: no-repeat;
  }

  .swiper-button-next {
    background-image: url(${IcChevronRightBlack});
    background-position: center;
    background-repeat: no-repeat;
  }

  .swiper-button-next,
  .swiper-container-rtl .swiper-button-prev {
    right: 30px;
  }

  .swiper-button-prev,
  .swiper-container-rtl .swiper-button-next {
    left: 30px;
  }

  .swiper-slide {
    cursor: pointer;
    max-height: 46px;
    opacity: 0.4;
    width: 80px;
  }

  .swiper-slide-thumb-active {
    opacity: 1;
  }

  @media (max-width: 1366px) {
    .swiper-button-next,
    .swiper-container-rtl .swiper-button-prev {
      right: 8%;
    }

    .swiper-button-prev,
    .swiper-container-rtl .swiper-button-next {
      left: 8%;
    }
  }
`

export const ImageSelect = styled.div`
  align-items: center;
  display: flex;
  flex-direction: column;

  img {
    width: 100%;
  }
`

export const Bullet = styled.div`
  margin-bottom: 20px;
  max-height: 16vh;

  .swiper-container {
    .swiper-slide {
      img {
        max-width: 80px;
      }
    }
  }
`
